<template>
    <b-row>
        <div class="col-sm-12">
            <h3>Re imprimir Recibos</h3>
        </div>
        <div v-if="tipo_busqueda == 'fecha'" class="col-sm-5 mt-3">
            <label for="" class="form-label">Fecha Inicial</label>
            <input type="date" class="form-control form-control-sm" v-model="fecha_inicial" />
        </div>
        <div v-if="tipo_busqueda == 'fecha'" class="col-sm-5 mt-3">
            <label for="" class="form-label">Fecha Final</label>
            <input type="date" class="form-control form-control-sm" v-model="fecha_final" />
        </div>

        <div class="col-sm-2 mt-5">
            <button type="button" class="btn btn-sm btn-outline-dark btn-block" @click="obtener_registros">
                Buscar
            </button>
        </div>

        <div class="col-sm-12 mt-3">
            <div class="marco_reimpresion">
                <table class="table table-sm table-striped table-bordered" style="font-size: 13px">
                    <thead>
                        <tr>
                            <th style="width: 10%; text-align: center">FECHA</th>
                            <th style="width: 10%; text-align: center">NIT</th>
                            <th style="width: 50%">NOMBRE CLIENTE</th>
                            <th style="width: 10%;text-align: center;">MONTO</th>
                            <th style="width: 10%;text-align: center;">TDP</th>
                            <th style="width: 10%; text-align: center">...</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in registros" :key="index">
                            <td style="text-align: center">
                                {{ item.fecha_movimiento }}
                            </td>
                            <td style="text-align: center">
                                {{ item.nit_cliente }}
                            </td>
                            <td>
                                {{ item.nombre_cliente }}
                            </td>
                            <td style="text-align: center;">
                                Q{{ (item.total_movimiento - item.total_descuentos__).toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                }) }}
                            </td>
                            <td style="text-align:center;">
                                {{ item.tipo_de_pago }}
                            </td>
                            <td style="text-align: center">
                                <button type="button" class="btn btn-sm btn-outline-dark" style="font-size: 10px"
                                    @click="reimprimir_factura(item)">
                                    <i class="fas fa-print"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </b-row>
</template>

<script>
    import { minix } from "@/components/functions/alertas";
    import moment from "moment";
    import { mapActions, mapState } from "vuex";

    export default {
        name: "ReImpresion",
        computed: {
            ...mapState(['datos_usuario', 'id_empresa_seleccionada', 'nombre_empresa_seleccionada'])
        },
        data() {
            return {
                tipo_busqueda: "fecha",
                fecha_inicial: moment(Date.now()).format("YYYY-MM-DD"),
                fecha_final: moment(Date.now()).format("YYYY-MM-DD"),
                nit: "",
                descuento: 0,
                registros: [],
            };
        },
        methods: {
            async cerrar() {
                this.$emit("salir");
            },
            limpiar_registros() {
                this.registros = [];
                this.nit = "";
            },
            async obtener_registros() {
                let f = {
                    api: `movimientos-cabeceras/r/reimpresion?empresa=${this.id_empresa_seleccionada
                        }&vendedor=${this.datos_usuario.id}&sucursal=${this.datos_usuario.sucursal_asignada
                        }&fecha_inicial=${this.fecha_inicial}&fecha_final=${this.fecha_final
                        }&nit=${this.nit.trim()}&tipo_busqueda=${this.tipo_busqueda}&tipo_impresion=recibo`,
                };

                let r = await this.obtener_data(f);

                if (r.length == 0) {
                    minix({
                        icon: "info",
                        mensaje: "No se encontraron registros",
                        tiempo: 3000,
                    });
                } else {
                    this.registros = r;
                }
            },
            async reimprimir_factura(r) {

                let hxs = 0

                // Insertando de manera dinámica los productos y calculando el descuento total
                for (let i = 0; i < r.detalle_movimientos.length; i++) {
                    const e = r.detalle_movimientos[i];
                    if (e.tipo_de_pago == 'efectivo' || e.tipo_de_pago == 'EFECTIVO') {
                        hxs += ((e.precio_venta - e.precio_efectivo) * Math.abs(e.cantidad))
                    } else {
                        hxs += e.descuento
                    }
                }

                this.descuento = hxs

                const docDefinition = {
                    pageSize: {
                        width: 226.77, // 80mm en puntos (1mm = 2.83465 puntos)
                        height: 'auto'
                    },
                    pageMargins: [5, 5, 5, 5], // Márgenes mínimos para impresora térmica
                    content: [
                        {
                            text: this.nombre_empresa_seleccionada,
                            style: 'header',
                            alignment: 'center'
                        },
                        {
                            text: r.datos_sucursal.establecimiento,
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: r.datos_sucursal.direccion,
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: '----------------------------------------',
                            alignment: 'center'
                        },
                        {
                            text: '*** RECIBO ***',
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: `NIT: ${r.nit_cliente}`,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: `CLI: ${r.nombre_cliente}`,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: '-------------------------------------------------------------------',
                            style: 'separador',
                            alignment: 'center'
                        },
                        {
                            columns: [
                                { text: 'DESCRIPCION', style: 'tableHeader', width: '58%' },
                                { text: 'CANT.', style: 'tableHeader', width: '20%' },
                                { text: 'MONTO', style: 'tableHeader', width: '22%' }
                            ]
                        },
                        {
                            text: '-------------------------------------------------------------------',
                            style: 'separador',
                            alignment: 'center'
                        },
                        // Agrega aquí las filas de productos
                        // {
                        //     columns: [
                        //         { text: 'ALA', style: 'descripcion', width: '50%' },
                        //         { text: '10', style: 'cantidad', width: '20%' },
                        //         { text: 'Q100.00', style: 'monto', width: '30%' }
                        //     ]
                        // },
                        {
                            text: '-------------------------------------------------------------------',
                            style: 'separador',
                            alignment: 'center'
                        },
                        {
                            columns: [
                                { text: 'Descuento', style: 'total_2', width: '70%' },
                                {
                                    text: `Q${hxs.toLocaleString(undefined, {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2
                                    })}`, style: 'cantidad_total_2', width: '30%'
                                }
                            ]
                        },
                        {
                            columns: [
                                { text: 'Total', style: 'total', width: '70%' },
                                {
                                    text: `Q${(r.total_movimiento - hxs).toLocaleString(undefined, {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2
                                    })}`, style: 'cantidad_total', width: '30%'
                                }
                            ]
                        },
                        {
                            text: '',
                            style: 'espacio',
                            alignment: 'center'
                        },
                        {
                            text: '',
                            style: 'espacio',
                            alignment: 'center'
                        },
                        {
                            text: 'RECIBO',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: 'Gracias por su compra',
                            bold: true,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: '**',
                            style: 'pie_ticket',
                            alignment: 'center'
                        }
                    ],
                    // margin: [left, top, right, bottom]
                    styles: {
                        header: {
                            fontSize: 11,
                            bold: true,
                            margin: [0, 20, 0, 5]
                        },
                        subheader: {
                            fontSize: 10,
                            margin: [0, 0, 0, 3]
                        },
                        normal: {
                            fontSize: 10,
                            margin: [0, 0, 0, 3]
                        },
                        separador: {
                            fontSize: 11,
                            margin: [0, -5, 0, 0]
                        },
                        tableHeader: {
                            fontSize: 10,
                            bold: true,
                            margin: [6, -5, 5, 0]
                        },
                        descripcion: {
                            fontSize: 9,
                            margin: [6, 0, 0, 0]
                        },
                        cantidad: {
                            fontSize: 9,
                            margin: [30, 0, 0, 0]
                        },
                        monto: {
                            fontSize: 9,
                            margin: [15, 0, 0, 0]
                        },
                        total: {
                            fontSize: 9,
                            bold: true,
                            margin: [130, 0, 0, 20]
                        },
                        total_2: {
                            fontSize: 9,
                            bold: true,
                            margin: [105, 0, 0, 0]
                        },
                        cantidad_total: {
                            fontSize: 9,
                            margin: [15, 0, 0, 20]
                        },
                        cantidad_total_2: {
                            fontSize: 9,
                            margin: [15, 0, 0, 0]
                        },
                        espacio: {
                            fontSize: 10,
                            margin: [0, 0, 0, 10]
                        },
                        pie_ticket: {
                            fontSize: 10,
                            margin: [0, 50, 0, 0]
                        }

                    }
                };

                // Insertando de manera dinamica los productos

                let posicion_a_insertar = 10

                for (let i = 0; i < r.detalle_movimientos.length; i++) {
                    const e = r.detalle_movimientos[i];

                    docDefinition.content.splice(posicion_a_insertar, 0, {
                        columns: [
                            { text: e.nombre_producto_re, style: 'descripcion', width: '50%' },
                            { text: Math.abs(e.cantidad), style: 'cantidad', width: '20%' },
                            {
                                text: `Q${(Math.abs(e.cantidad) * e.precio_venta).toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                })}`, style: 'monto', width: '30%'
                            }
                        ]
                    })

                    posicion_a_insertar++

                }

                // Crear y descargar el PDF
                pdfMake.createPdf(docDefinition).open();
            },
            ...mapActions(["obtener_data"]),
        },
    };
</script>

<style></style>